module.exports = __webpack_public_path__ + "static/media/nickkraly_resume_2018_v1.8670efa6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/nickkraly_resume_2018_v1.pdf
// module id = 362
// module chunks = 0